module.exports = __webpack_public_path__ + "static/media/expert (2).475301f3.png";